<div id="spinner_id"  class="spin">
  <div class="loader">
    <img aria-hidden="true" src="assets/images/Spinner-24px.svg" alt="" />
    <div class="sr-only">{{loadingText}}</div>
  </div>
</div>